import React, { useEffect } from 'react';
import { useUIConfig } from '../../hooks/useUIConfig';

// Higher-order component that makes any element configurable
const ConfigurableElement = ({ 
  children, 
  section, 
  element, 
  className = '', 
  style = {},
  ...props 
}) => {
  const { getElementConfig, applyCSS } = useUIConfig();

  useEffect(() => {
    // Apply CSS when component mounts or config changes
    applyCSS();
    
    // Force a small delay to ensure styles are applied
    setTimeout(() => {
      applyCSS();
    }, 50);
  }, [applyCSS]);

  const elementConfig = getElementConfig(section, element);
  const configClassName = elementConfig ? `${section}-${element}` : '';
  
  // Merge custom styles with config styles
  const mergedStyle = {
    ...style,
    ...(elementConfig?.position || {}),
    ...(elementConfig?.size || {}),
    ...(elementConfig?.transform && { transform: elementConfig.transform })
  };

  return (
    <div 
      className={`${configClassName} ${className}`.trim()}
      style={mergedStyle}
      {...props}
    >
      {children}
    </div>
  );
};

// Specific configurable components for common use cases
export const ConfigurableImage = ({ 
  src, 
  alt, 
  section, 
  element, 
  className = '', 
  style = {},
  ...props 
}) => {
  const { getElementConfig, applyCSS } = useUIConfig();

  useEffect(() => {
    applyCSS();
  }, [applyCSS]);

  const elementConfig = getElementConfig(section, element);
  const configClassName = elementConfig ? `${section}-${element}` : '';
  
  const mergedStyle = {
    ...style,
    ...(elementConfig?.position || {}),
    ...(elementConfig?.size || {}),
    ...(elementConfig?.transform && { transform: elementConfig.transform })
  };

  return (
    <img 
      src={src}
      alt={alt}
      className={`${configClassName} ${className}`.trim()}
      style={mergedStyle}
      {...props}
    />
  );
};

export const ConfigurableContainer = ({ 
  children, 
  section, 
  element, 
  className = '', 
  style = {},
  ...props 
}) => {
  const { getElementConfig, applyCSS } = useUIConfig();

  useEffect(() => {
    applyCSS();
  }, [applyCSS]);

  const elementConfig = getElementConfig(section, element);
  const configClassName = elementConfig ? `${section}-${element}` : '';
  
  const mergedStyle = {
    ...style,
    ...(elementConfig?.position || {}),
    ...(elementConfig?.size || {}),
    ...(elementConfig?.transform && { transform: elementConfig.transform })
  };

  return (
    <div 
      className={`${configClassName} ${className}`.trim()}
      style={mergedStyle}
      {...props}
    >
      {children}
    </div>
  );
};

export default ConfigurableElement;
